
// HULKAPPS WISHLIST HOTFIX: Prevents deleting items from the Shared wishlist
(function() {
    // Activate the hotfix only if we are on the Shared Wishlist page
    if (window.location.href.indexOf('/share?listID=') !== -1) {
        
        var originalOpen = window.XMLHttpRequest.prototype.open;
        var originalSend = window.XMLHttpRequest.prototype.send;

        // Store the URL of every request
        window.XMLHttpRequest.prototype.open = function(method, url) {
            this._url = url;
            return originalOpen.apply(this, arguments);
        };

        // Intercept the send method
        window.XMLHttpRequest.prototype.send = function(body) {
            // If the request is targeting delete_product, block it!
            if (this._url && this._url.indexOf('delete_product') !== -1) {
                console.log('HulkApps Hotfix: Blocked attempt to delete products from a shared wishlist.');
                
                // Modify properties to simulate a 200 OK response
                // This prevents the screen from freezing because the app thinks the request was successful
                Object.defineProperty(this, 'readyState', { value: 4, writable: false });
                Object.defineProperty(this, 'status', { value: 200, writable: false });
                Object.defineProperty(this, 'responseText', { value: '{"status":"ok"}', writable: false });
                
                // Trigger events so the original Hulk script continues its execution (e.g., redirect)
                if (typeof this.onreadystatechange === 'function') {
                    this.onreadystatechange();
                }
                if (typeof this.onload === 'function') {
                    this.onload();
                }
                
                // return CANCELS the actual request to the backend
                return; 
            }
            
            // For all other requests (e.g., add_product), proceed normally
            return originalSend.apply(this, arguments);
        };
    }
})();
